<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, code, form, fieldset, legend, input, textarea, p, blockquote, th, td {
    margin: 0;
    padding: 0;
  }

  a {
    text-decoration: none;
  }

  ul, ol {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  img {
    vert-align: top;
  }

  a,
  input,
  button {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  input，textarea {
    outline: none
  }

  input,
  button {
    -webkit-appearance: none;
    border-radius: 0;
  }

  body {
    margin: 0;
  }

  body * {
    font-family: Helvetica;
  }

  /*body {*/
    /*-ms-text-size-adjust: 100%;*/
    /*-webkit-text-size-adjust: 100%;*/
  /*}*/

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue